import React from 'react';


const footer = (props) => (
    <div classname='copyright'>
        <h5>© BDS Quality services 2026</h5>
    </div>
);

export default footer